import React, { Component } from 'react';
import MobileBar from '../Site/MobileBar';
import ProductBinDeleteDetail from './ProductBinDeleteDetail';

import './style.css';

class ProductBinDelete extends Component {

  render() {
    return (
      <div>
        <MobileBar />
        <ProductBinDeleteDetail />
      </div>
    );
  }
}

export default ProductBinDelete;
